import React, {useState} from 'react';
import {Checkbox} from "primereact/checkbox";
import {InputText} from "primereact/inputtext";

import {AppContext} from "../../HomePage";
import {readMarketplaceOperator, parseMarketplaceList} from "./marketplaceOperatorSettings";

// Shared editor for settings.marketplace_operator, used by both campaign settings
// screens. `value` is the (possibly raw) setting object, `onChange` receives the
// next raw object; the screens normalize keys when they write it to the settings.
// `hasSellerCode` tells whether the campaign has a Seller Code, which holds the
// operator's own seller name and makes its own offer the 1P price.
const MarketplaceOperatorSettingsFields = ({value, onChange, hasSellerCode}) => {
    const {t} = React.useContext(AppContext);
    const current = readMarketplaceOperator({marketplace_operator: value});

    // Raw text of the competitor list. It stays in local state so typing is never
    // altered; the parsed keys go to the setting on every change, so what is saved
    // always matches what is shown.
    const [competitorsText, setCompetitorsText] = useState(current.competitor_marketplaces.join(', '));

    const update = (patch) => onChange({...current, ...patch});

    return (
        <div style={{padding: '6px 0'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
                <Checkbox inputId="marketplace_operator_enabled" checked={current.enabled}
                          onChange={(e) => update({enabled: !!e.checked})}/>
                <label htmlFor="marketplace_operator_enabled" style={{margin: 0}}>{t('campaign.marketplace_operator.enabled')}</label>
            </div>
            {current.enabled && (
                <div style={{display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8, paddingLeft: 4}}>
                    <div>
                        <label htmlFor="marketplace_operator_own_key"
                               style={{display: 'block', fontSize: '.8rem', color: '#6b7280', marginBottom: 4}}>
                            {t('campaign.marketplace_operator.own_marketplace_key')}
                        </label>
                        <InputText id="marketplace_operator_own_key" value={current.own_marketplace_key}
                                   style={{width: '100%'}}
                                   onChange={(e) => update({own_marketplace_key: e.target.value})}/>
                        {!current.own_marketplace_key.trim() &&
                            <small style={{display: 'block', color: '#b45309', marginTop: 4}}>
                                {t('campaign.marketplace_operator.missing_key_warning')}
                            </small>}
                    </div>
                    <div>
                        <label htmlFor="marketplace_operator_competitors"
                               style={{display: 'block', fontSize: '.8rem', color: '#6b7280', marginBottom: 4}}>
                            {t('campaign.marketplace_operator.competitor_marketplaces')}
                        </label>
                        <InputText id="marketplace_operator_competitors" value={competitorsText}
                                   placeholder="trendyol, hepsiburada, n11" style={{width: '100%'}}
                                   onChange={(e) => {
                                       setCompetitorsText(e.target.value);
                                       update({competitor_marketplaces: parseMarketplaceList(e.target.value)});
                                   }}/>
                    </div>
                    {!hasSellerCode &&
                        <small style={{display: 'block', color: '#b45309'}}>
                            {t('campaign.marketplace_operator.missing_seller_code_warning')}
                        </small>}
                </div>
            )}
        </div>
    );
};

export default MarketplaceOperatorSettingsFields;
